import { useState } from 'react';
import { QrCodeList } from './components/QrCodeList';
import { QrCodeCreate } from './components/QrCodeCreate';
import { QrCodeView } from './components/QrCodeView';
import type { QrCodeRecord, QrCodeType } from './api/types';

type View = { mode: 'list' } | { mode: 'create' } | { mode: 'view'; record: QrCodeRecord };

export function QrCodesTab() {
  const [activeType, setActiveType] = useState<QrCodeType>('campaign');
  const [view, setView] = useState<View>({ mode: 'list' });
  const [flash, setFlash] = useState<string | null>(null);

  const switchTab = (next: QrCodeType) => {
    setActiveType(next);
    setView({ mode: 'list' });
    setFlash(null);
  };

  const handleCreated = (record: QrCodeRecord) => {
    setFlash(`Created “${record.campaign_name}”. Slug: ${record.campaign_id}`);
    setView({ mode: 'list' });
  };

  return (
    <div className="space-y-5">
      <div className="flex items-center gap-1 border-b border-gray-800">
        {(['campaign', 'permanent'] as QrCodeType[]).map((t) => (
          <button
            key={t}
            type="button"
            onClick={() => switchTab(t)}
            className={[
              'px-4 py-2 text-sm font-medium -mb-px border-b-2 transition-colors',
              activeType === t
                ? 'text-violet-300 border-violet-500'
                : 'text-gray-400 border-transparent hover:text-gray-200',
            ].join(' ')}
          >
            {t === 'campaign' ? 'Campaigns' : 'Permanent QRs'}
          </button>
        ))}
      </div>

      {flash && (
        <div className="rounded-md border border-emerald-900/50 bg-emerald-950/30 px-3 py-2 text-sm text-emerald-300 flex items-center justify-between">
          <span>{flash}</span>
          <button
            type="button"
            onClick={() => setFlash(null)}
            className="text-emerald-400/70 hover:text-emerald-200"
            aria-label="Dismiss"
          >
            ×
          </button>
        </div>
      )}

      {view.mode === 'list' && (
        <QrCodeList
          type={activeType}
          onCreate={() => setView({ mode: 'create' })}
          onSelect={(record) => setView({ mode: 'view', record })}
        />
      )}

      {view.mode === 'create' && (
        <QrCodeCreate
          type={activeType}
          onCancel={() => setView({ mode: 'list' })}
          onCreated={handleCreated}
        />
      )}

      {view.mode === 'view' && (
        <QrCodeView
          initial={view.record}
          onBack={() => setView({ mode: 'list' })}
        />
      )}
    </div>
  );
}
